import { styled } from '@mui/material/styles'
import { Select } from '@mui/material'

export const InputSelect = styled(Select)({
    width: '100%',
    textAlign: 'left',

    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#A69478 !important',
    },

    '& .MuiOutlinedInput-root': {
        '& input': {
            borderColor: '#707070',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#A69478',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#707070',
        },
    },
})
